import { useQueryClient as s, useMutation as u } from "@tanstack/vue-query";
import { adGroupKeys as o } from "../ad-group/queries.js";
import { creativeGroupKeys as y } from "../creative-group/queries.js";
import { targetGroupKeys as m } from "../target-group/queries.js";
import { campaignKeys as c } from "./queries.js";
const C = (r, i) => {
  const n = s(), e = i?.onSuccess;
  return u({
    ...i,
    mutationFn: async (a) => {
      const t = a.body;
      return r.campaign.create(t);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: c.all }), e && e(...a);
    }
  });
}, I = (r, i) => {
  const n = s(), e = i?.onSuccess;
  return u({
    ...i,
    mutationFn: async (a) => {
      const t = {
        campaignId: a.campaignId,
        ...a.body
      };
      await r.campaign.update(t);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: c.all }), e && e(...a);
    }
  });
}, f = (r, i) => {
  const n = s(), e = i?.onSuccess;
  return u({
    ...i,
    mutationFn: async (a) => {
      const t = {
        campaignId: a.campaignId,
        ...a.body
      };
      await r.campaign.rename(t);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: c.all }), e && e(...a);
    }
  });
}, K = (r, i) => {
  const n = s(), e = i?.onSuccess;
  return u({
    ...i,
    mutationFn: async (a) => r.campaign.remove({
      params: { campaignId: a.campaignId },
      query: { force: a.force ?? !1 }
    }),
    onSuccess: async (...a) => {
      const [, t] = a;
      n.removeQueries({ queryKey: c.byCampaign(t.campaignId) }), n.removeQueries({ queryKey: o.byCampaign(t.campaignId) }), n.removeQueries({ queryKey: y.byCampaign(t.campaignId) }), n.removeQueries({ queryKey: m.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: c.all }), e && e(...a);
    }
  });
}, Q = (r, i) => {
  const n = s();
  return u({
    ...i,
    mutationFn: async (e) => {
      const a = {
        campaignId: e.campaignId,
        ...e.body
      };
      await r.campaign.update(a);
    },
    onMutate: async (e) => {
      await n.cancelQueries({
        queryKey: c.detail(e.campaignId)
      });
      const a = n.getQueryData(c.detail(e.campaignId));
      return a && n.setQueryData(c.detail(e.campaignId), {
        ...a,
        ...e.body
      }), { previousDetail: a };
    },
    onError: (e, a, t) => {
      t?.previousDetail !== void 0 && n.setQueryData(c.detail(a.campaignId), t.previousDetail);
    },
    onSettled: async () => {
      await n.invalidateQueries({ queryKey: c.all });
    }
  });
};
export {
  C as useCreateCampaign,
  K as useDeleteCampaign,
  f as useRenameCampaign,
  I as useUpdateCampaign,
  Q as useUpdateCampaignOptimistic
};
//# sourceMappingURL=mutations.js.map
